var render = function render(){var _vm=this,_c=_vm._self._c;return _c('AppButton',_vm._b({class:['a-btn', _vm.type],attrs:{"padding":"20px 50px"}},'AppButton',{ ..._vm.$attrs, ..._vm.style },false))
}
var staticRenderFns = []

export { render, staticRenderFns }